export const availableFields = {
  name: {
    name: 'name',
    type: 'FormText',
    label: 'Nome',
    width: 50,
    mandatory: true,
    validators: {
      required: true,
      min: 2,
      alpha_spaces: true,
    },
  },
  surname: {
    name: 'surname',
    type: 'FormText',
    label: 'Sobrenome',
    mandatory: true,
    validators: {
      required: true,
      min: 2,
      alpha_spaces: true,
    },
    width: 50,
  },
  phone: {
    name: 'phone',
    type: 'FormText',
    label: 'Celular',
    width: 50,
    mask: ['+55 (##) ####-#####', '+55 (##) # ####-####'],
    placeholder: '(99) 9 9999-9999',
    mandatory: true,
    validators: {
      required: true,
      telefoneValido: true,
    },
  },
  email: {
    name: 'email',
    type: 'FormText',
    label: 'E-mail',
    width: 50,
    mandatory: true,
    validators: {
      email: true,
      required: true,
    },
    backend: ['checkUniqueEmail'],
  },
  birth_date: {
    name: 'birth_date',
    type: 'FormText',
    label: 'Data de nascimento',
    mask: ['##/##/####'],
    placeholder: 'DD/MM/YYYY',
    width: 100,
    mandatory: true,
    validators: {
      required: true,
      dataValida: true,
      idadeMinima: 18,
      idadeMaxima: 110,
    },
  },
  gender: {
    name: 'gender',
    type: 'FormRadio',
    label: 'Gênero',
    width: 100,
    mandatory: true,
    validators: {
      required: true,
    },
    options: [
      {
        label: 'Feminino',
        value: 'F',
      },
      {
        label: 'Masculino',
        value: 'M',
      },
      {
        label: 'Prefiro não informar',
        value: 'U',
      },
    ],
  },
  address: {
    name: 'address',
    type: 'FormAddress',
    label: 'Endereço',
    width: 100,
    mandatory: true,
  },
  state_registration: {
    name: 'state_registration',
    type: 'FormText',
    label: 'Inscrição Estadual',
    mask: ['####################################'],
    width: 100,
    mandatory: true,
  },
  fantasy_name: {
    name: 'name',
    type: 'FormText',
    label: 'Razão social',
    width: 100,
    mandatory: true,
    validators: {
      required: true,
      min: 2,
    },
  },
  password: {
    name: 'password',
    type: 'FormPassword',
    width: 100,
    label: 'Senha',
    mandatory: false,
    validators: {
      required: true,
      min: 6,
    },
  },
  landline: {
    name: 'landline',
    type: 'FormText',
    label: 'Telefone Contato',
    width: 100,
    mask: ['+55 (##) ####-#####', '+55 (##) # ####-####'],
    placeholder: '(99) 9999-9999',
    validators: {
      required: true,
      telefoneValido: true,
    },
  },
  checkbox: {
    name: 'checkbox',
    type: 'FormCheckbox',
    label: 'Checkbox',
    width: 100,
    validators: {
      required: true,
    },
    extra_data: true,
    options: [
      {
        label: 'Opção 1',
        value: '1',
      },
      {
        label: 'Opção 2',
        value: '2',
      },
      {
        label: 'Opção 3',
        value: '3',
      },
    ],
  },
  select: {
    name: 'select',
    type: 'FormSelect',
    label: 'Select example',
    width: 100,
    extra_data: true,
    options: [
      {
        label: 'Option 1',
        value: '1',
      },
      {
        label: 'Option 2',
        value: '2',
      },
      {
        label: 'Option 3',
        value: '3',
      },
    ],
  },
}

export const defaultFields = {
  natural: [
    availableFields['name'],
    availableFields['surname'],
    availableFields['phone'],
    availableFields['email'],
    availableFields['birth_date'],
    availableFields['gender'],
    availableFields['address'],
    availableFields['password'],
  ],
  legal: [
    availableFields['state_registration'],
    availableFields['fantasy_name'],
    availableFields['phone'],
    availableFields['email'],
    availableFields['landline'],
    availableFields['address'],
    availableFields['password'],
  ],
}

export const customValidators = ['telefoneValido', 'dataValida', 'idadeMinima', 'idadeMaxima']
